import React from "react";
import { Helmet } from "react-helmet-async";
import { useLocation } from "react-router-dom";
import { useLang } from "../contexts/LangContext";

const SITE_NAME = "Corsa Exchange";
const DEFAULT_OG = "https://corsaexchange.ro/logoWEB.png";

const SEO = ({ title, description, image, type = "website" }) => {
  const { lang } = useLang();
  const { pathname, search } = useLocation();
  const siteBase =
    (typeof window !== "undefined" && window.location.origin) ||
    process.env.REACT_APP_BACKEND_URL ||
    "https://corsaexchange.ro";

  const cleanPath = pathname.replace(/\/+$/, "") || "/";
  const canonical = `${siteBase}${cleanPath}`;
  const fullTitle = title ? `${title} · ${SITE_NAME}` : SITE_NAME;

  return (
    <Helmet htmlAttributes={{ lang }}>
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={canonical} />
      <link rel="alternate" hrefLang="ro" href={canonical} />
      <link rel="alternate" hrefLang="en" href={`${canonical}?lang=en`} />
      <link rel="alternate" hrefLang="x-default" href={canonical} />
      <meta property="og:type" content={type} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={canonical} />
      <meta property="og:image" content={image || DEFAULT_OG} />
      <meta property="og:locale" content={lang === "en" ? "en_US" : "ro_RO"} />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image || DEFAULT_OG} />
    </Helmet>
  );
};

export default SEO;
